/**
 * Exploitation de la plateforme : tâches planifiées.
 *
 * Ensembles fermés partagés entre la base (pgEnum), le serveur (zod) et le front (libellés i18n).
 * Règle : valeurs ASCII en snake_case, jamais de libellé humain ici. Ce fichier est réexporté par
 * `../enums.js`, qui reste le seul point d'entrée : personne n'importe un domaine directement.
 */

/**
 * Issue d'une exécution de tâche planifiée. `skipped_locked` n'est pas un échec : une autre
 * instance tenait le verrou consultatif et a fait le travail. La V1 verrouillait en mémoire,
 * donc deux instances faisaient le travail deux fois sans jamais le savoir.
 */
export const jobRunStatuses = ['succeeded', 'failed', 'skipped_locked'] as const;
export type JobRunStatus = (typeof jobRunStatuses)[number];

/**
 * Issue d'un envoi de courriel, telle que notre journal la retient. Deux valeurs : le transport a
 * accepté le message, ou il l'a refusé. Ce qu'il advient ensuite — délivré, rejeté par le serveur
 * du destinataire, classé indésirable — ne nous est pas rapporté par SMTP et se lit chez le
 * fournisseur ; c'est pourquoi la console montre les deux sources côte à côte.
 */
export const emailDeliveryStatuses = ['sent', 'failed'] as const;
export type EmailDeliveryStatus = (typeof emailDeliveryStatuses)[number];
